var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinterEmpty = function SvgPrinterEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    stroke: "#666666",
    strokeDasharray: "1 6",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#printer-empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27 16v-1.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C25.48 11 24.92 11 23.8 11h-5.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C15 12.52 15 13.08 15 14.2V16m0 11c-.93 0-1.395 0-1.777-.102a3 3 0 0 1-2.12-2.122C11 24.396 11 23.93 11 23v-2.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C13.28 16 14.12 16 15.8 16h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C31 18.28 31 19.12 31 20.8V23c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C28.396 27 27.93 27 27 27m-3-7.5h3M18.2 31h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C27 29.48 27 28.92 27 27.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C25.48 23 24.92 23 23.8 23h-5.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C15 24.52 15 25.08 15 26.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C16.52 31 17.08 31 18.2 31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "printer-empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 9.5h22v22h-22z"
  })))));
};
export default SvgPrinterEmpty;